// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import { Location } from '@angular/common';
import * as _ from 'lodash';
// Services
import { BookingHolidayService } from '../../../services';
import { SessionStorageService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
import { ClassPayment, ClassChild, BookingItem, Semester } from '../../../models';

@Component({
    selector: 'children-list',
    template: require('./ChildrenListComponent.html'),
    styles: [ require('./ChildrenListComponent.sass') ]
})

export class ChildrenListComponent extends BookingComponent implements OnInit {
    private children: any[];
    private parent: any
    private currentSemester: Semester;
    //chỗ này chỉnh tạm dù cho là S1 hay S2 thì đều chuyển hướng tói màn hình Activity list thay vì Questionaire 
    private isWinterSemester: Boolean = true;

    constructor(
        protected router: Router,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected catalogService: CatalogService,
        protected location: Location
        
    ){
        super(router, services, sessionStorageService, catalogService);
        // Remove session data
        local.removeData('classReservation');
        local.removeData('bookingItem');
    }

    ngOnInit() {
        // Get classChildren from API.
        this.getChildren();
        this.getSemesterList();

        // Remove old data on init
        this.sessionStorageService.removeData("answerList");
        this.sessionStorageService.removeData('holidayBooking');
    }

    protected getSemesterList() {
        this.catalogService.getSemesters()
            .subscribe(
                semesterList => {
                    this.currentSemester = _.find(semesterList, 'is_current');
                    if(this.currentSemester.is_current && this.currentSemester.name == 'Semester 1') {
                        this.isWinterSemester = true;
                    }
                },
                error => {
                    console.log("Cannot get semester list from API.");
                }
            )
        
    }

    // Add chilren for non ais parent
    addChildren() {
        this.router.navigateByUrl('/add-student');
    }

    // Get all children of logged parent
    getChildren() {
        // Loading data indicator
        this.loading = true;
        this.services.getChildren().subscribe(
            result => {
                this.parent = result.type;
                // Get all children
                if(result.holStudents){
                    this.children = _.filter(result.holStudents, {'status': 'active'});
                }
                
                // Set session children to avoid re-request
                this.setHolidayChildren(result);
                // Hide loading
                this.loading = false;
            },
            error => {

            }
        )
    }

    /**
     * Navigate to class list
     */
    private toNextStep(child: any) {
        // Set selected child
        this.setSelectedChild(child);
        // Start booking session countdown
        this.services.startCountdown(true);
        // Navigate to activities page
        this.isWinterSemester ?  this.toActivitiesListPage() : this.toQuestionAnswerPage();
    }

    // View booking info
    toViewBooking(child: any) {
        let booking : any = _.find(child.hol_bookings, (o:any) => { return o.status == 'accepted' || o.status == 'waited'})
        return this.router.navigate(['booking', booking.id]);            
    }

    // To Edit booking
    private toEditBooking(child: any){
        let query = {
            id: child.hol_bookings[0].id,
            page: 1
        };

        this.services.getBooking(query)
            .subscribe(
                result => {
                    let booking = result.data[0];
                    // Reinit periodWeeks
                    booking.periodWeeks = [];
                    booking.period = [];
                    // If max weeks allow in history
                    if(booking.hol_weeks.length == 5){
                        booking.period[booking.hol_class_id] = 'full'                        
                    }
                    else{
                        booking.period[booking.hol_class_id] = 'period'
                    }

                    // Reinit bus info
                    if(booking.hol_booking_buses.length){
                        // Detect bus type
                        booking.busType = booking.hol_booking_buses[0].price ? 'paid' : 'free';
                        // Set bus info
                        booking.bus = {
                            id: booking.hol_booking_buses[0].id,
                            district: booking.hol_booking_buses[0].district,
                            address: booking.hol_booking_buses[0].address,
                            price: booking.hol_booking_buses[0].price
                        } 
                    }

                    // Reinit tempBooking
                    if(booking.status == 'created'){
                        booking.temp = booking.id;                                                
                    }
                    if(booking.status == 'waited'){
                        booking.waiting = booking.id;                                                
                    }

                    // Reinit periodWeeks
                    _.forEach(booking.hol_weeks, (val, key) => {
                        booking.periodWeeks.push(val.id);
                    })

                    this.setBooking(booking)
                    return this.toNextStep(child)                       
                },
                error => {

                }
            )
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/1-children-list/ChildrenListComponent.ts